/**
 * CSS named colors approved as Faction colors. Mirrored from the same list on
 * the backend so the picker and the server validation stay in lockstep.
 * Storing the *name* (not the hex) means we can let CSS resolve it and we get
 * free XSS protection — any unknown name is rejected by the server.
 */
export const FACTION_COLORS = [
  "Aqua", "Aquamarine", "Bisque", "BlanchedAlmond",
  "Blue", "BlueViolet", "Brown", "BurlyWood",
  "CadetBlue", "Chartreuse", "Chocolate", "Coral",
  "CornflowerBlue", "Cornsilk", "Crimson", "Cyan",
  "DarkBlue", "DarkCyan", "DarkGoldenrod", "DarkGreen",
  "DarkKhaki", "DarkMagenta", "DarkOliveGreen", "DarkOrange",
  "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen",
  "DarkSlateBlue", "DarkTurquoise", "DarkViolet", "DeepPink",
  "DeepSkyBlue", "DodgerBlue", "FireBrick", "ForestGreen",
  "Fuchsia", "Gold", "Goldenrod", "Green",
  "GreenYellow", "HotPink", "IndianRed", "Indigo",
  "Khaki", "Lavender", "LawnGreen", "LemonChiffon",
  "LightBlue", "LightCoral", "LightCyan", "LightGoldenrodYellow",
  "LightGreen", "LightPink", "LightSalmon", "LightSeaGreen",
  "LightSkyBlue", "LightSteelBlue", "LightYellow", "Lime",
  "LimeGreen", "Magenta", "Maroon", "MediumAquamarine",
  "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSeaGreen",
  "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed",
  "MidnightBlue", "Moccasin", "NavajoWhite", "Navy",
  "Olive", "OliveDrab", "Orange", "OrangeRed",
  "Orchid", "PaleGoldenrod", "PaleGreen", "PaleTurquoise",
  "PaleVioletRed", "PapayaWhip", "PeachPuff", "Peru",
  "Pink", "Plum", "PowderBlue", "Purple",
  "Red", "RosyBrown", "RoyalBlue", "SaddleBrown",
  "Salmon", "SandyBrown", "SeaGreen", "Sienna",
  "SkyBlue", "SlateBlue", "SpringGreen", "SteelBlue",
  "Tan", "Teal", "Thistle", "Tomato",
  "Turquoise", "Violet", "Wheat", "Yellow",
  "YellowGreen",
];

export const FACTION_COLOR_SET = new Set(FACTION_COLORS.map((c) => c.toLowerCase()));

/**
 * Some swatches are nearly white and unreadable against the dark site bg —
 * for those we render the acronym in near-black, else in white.
 */
const LIGHT_SWATCHES = new Set(
  [
    "Bisque", "BlanchedAlmond", "Cornsilk", "Khaki", "Lavender",
    "LemonChiffon", "LightBlue", "LightCyan", "LightGoldenrodYellow",
    "LightGreen", "LightPink", "LightYellow", "Moccasin", "NavajoWhite",
    "PaleGoldenrod", "PaleGreen", "PaleTurquoise", "PapayaWhip", "PeachPuff",
    "Pink", "PowderBlue", "Thistle", "Wheat", "Yellow", "Aquamarine",
    "Aqua", "Cyan", "GreenYellow", "LightSkyBlue", "LightSteelBlue",
    "Lime", "MediumSpringGreen", "SpringGreen", "Tan",
  ].map((c) => c.toLowerCase())
);

export function factionTextColor(name) {
  if (!name) return "#0D110C";
  return LIGHT_SWATCHES.has(name.toLowerCase()) ? "#0D110C" : "#FFFFFF";
}
